<div class="_w-full _h-full _relative">
    <div *ngIf="!start && useGradients[0]" 
        class="_mask-gradient-left-right _flex _items-center _justify-start _cursor-pointer"
        [ngClass]="{
            '_pl-4 _w-20': indentArrows,
            '_w-10': !indentArrows
        }"
        (click)="scrollBackwards()">
        <i *ngIf="useArrows[0]" class="fa-light fa-circle-chevron-left _text-h3-m hover:_opacity-70"></i>
    </div>
    <div class="_flex _justify-start _items-center _h-full _overflow-scroll _no-scrollbar " 
        [ngClass]="{ 
            '_justify-center': start && end,
            '_justify-start' : !start || !end 
        }"
        (scroll)="onScroll()" 
        #overflowContainer>
            <ng-content></ng-content>
    </div>
    <div *ngIf="!end && useGradients[1]" 
        class="_mask-gradient-right-left _flex _items-center _justify-end _cursor-pointer"
        [ngClass]="{
            '_pr-4 _w-20': indentArrows,
            '_w-10': !indentArrows
        }"
        (click)="scrollForwards()">
        <i *ngIf="useArrows[1]" class="fa-light fa-circle-chevron-right _text-h3-m hover:_opacity-70"></i>
    </div>
</div>
